import { Frown, RotateCcw } from "lucide-react";
import { Loader } from "lucide-react";

export default function Something({ refetch, isFetching }: any) {
  return (
    <div className="flex justify-center items-center">
      <div className="flex flex-col items-center my-20">
        <div className="flex items-center">
          <Frown size={40} color="#9ca3af" />
        </div>
        <div className="text-gray-400">Something went wrong</div>
        <button
          onClick={() => refetch()}
          className="flex items-center  px-6 py-1 pt-1 mt-2 bg-automark-dark text-white rounded-md"
        >
          <div className="">{isFetching ? <Loader /> : <RotateCcw />}</div>
          <span className="ml-1">Refresh</span>
        </button>
      </div>
    </div>
  );
}